import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {DataService} from '../data.service';
import {HhgBookShipmentAccessorialMsgs} from 'src/app/features/hhg-shipment-accessorial-additionalinfo/hhg-shipment-accessorial-additional';


@Injectable({
  providedIn: 'root'
})
export class HhgShipmentAccessorialAdditionalInfoService extends DataService {

  private baseURI = this.apiUri + '/hhgaccessorialMsgs/';

  constructor(http: HttpClient) {
    super(http);
  }

  getMessagesByAccessorialsId(bookAccessorialsId: any): Observable<any> {
    this.setUri(this.baseURI + bookAccessorialsId + '/bookAccessorialsId');
    return this.get();
  }

  deleteAccessorialMessages(bookAccessorialsId: any): Observable<any> {
    this.setUri(this.baseURI + 'deleteMessages');
    return this.update(bookAccessorialsId);
  }

  saveOrUpdateAccessorialMessages(HhgBookShipmentAccessorialMsg: HhgBookShipmentAccessorialMsgs[]): Observable<any> {
    this.setUri(this.baseURI + 'updateMessages');
    return this.update(HhgBookShipmentAccessorialMsg);
  }
}

